//export const URLROOT = 'https://hotdeskapi.chrisbriant.uk';
export const URLROOT = 'https://hotdeskapi.chrisbriant.uk';
